import React from 'react';

const Footer = () =>
	<div className="footer">
		<div>Contact Us: sales@abstractit.in</div>
	</div>;

export default Footer;
